/**
 * The reader's theme (P11.4): the system's, or light, or dark — kept in this
 * browser, applied as `data-theme` on `<html>`, which `tokens.css` turns into a
 * `color-scheme` that every `light-dark()` colour follows.
 *
 * A per-browser convenience, so `localStorage`, and every access guarded: a private
 * window or blocked site data makes it throw, and then the system's setting is
 * simply used.
 */

export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'bartizo-theme';

export function readTheme(): ThemeChoice {
  try {
    const stored = window.localStorage.getItem(KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset['theme'];
  else root.dataset['theme'] = choice;
}

export function saveTheme(choice: ThemeChoice): void {
  try {
    if (choice === 'system') window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, choice);
  } catch {
    // Not kept beyond this page; the choice still applies now.
  }
  applyTheme(choice);
}
